import {
	Rectangle,
	Round,
	hWall,
	vWall,
	Column,
	Plant,
	Bar,
	Exit,
	Wc,
	Chair,
	Sofa,
	hWindow,
	vWindow,
	BarChair,
	Bush,
	Tree,
	DoubleDoors,
	DoorRight,
	DoorLeft
} from './shapes'
import i18next from 'i18next'

export const getShape = (shape) => {
	switch (shape) {
		case 'roundTable': {
			return {
				Component: Round,
				shape: 'round',
				objectKind: 'table',
				width: 60,
				height: 60,
				title: i18next.t('restaurant_designer_section.strings.round_table')
			}
		}
		case 'rectangleTable': {
			return {
				Component: Rectangle,
				shape: 'rectangle',
				objectKind: 'table',
				width: 60,
				height: 60,
				title: i18next.t('restaurant_designer_section.strings.rectangle_table')
			}
		}
		case 'horizontalWall': {
			return {
				Component: hWall,
				shape: 'rectangle',
				objectKind: 'wall',
				width: 60,
				height: 10,
				title: i18next.t('restaurant_designer_section.strings.horizontal_wall')
			}
		}
		case 'verticalWall': {
			return {
				Component: vWall,
				shape: 'rectangle',
				objectKind: 'wall',
				width: 10,
				height: 60,
				title: i18next.t('restaurant_designer_section.strings.vertical_wall')
			}
		}
		case 'horizontalWindow': {
			return {
				Component: hWindow,
				shape: 'rectangle',
				objectKind: 'window',
				width: 60,
				height: 10,
				title: i18next.t('restaurant_designer_section.strings.horizontal_window')
			}
		}
		case 'verticalWindow': {
			return {
				Component: vWindow,
				shape: 'rectangle',
				objectKind: 'window',
				width: 10,
				height: 60,
				title: i18next.t('restaurant_designer_section.strings.vertical_window')
			}
		}
		case 'column': {
			return {
				Component: Column,
				shape: 'round',
				objectKind: 'column',
				width: 25,
				height: 25,
				title: i18next.t('restaurant_designer_section.strings.column')
			}
		}
		case 'tree': {
			return {
				Component: Tree,
				shape: 'round',
				objectKind: 'tree',
				width: 50,
				height: 50,
				title: 'Baum' // TODO: add translation
			}
		}
		case 'bush': {
			return {
				Component: Bush,
				shape: 'round',
				objectKind: 'bush',
				width: 40,
				height: 40,
				title: 'Busch' // TODO: add translation
			}
		}
		case 'plant': {
			return {
				Component: Plant,
				shape: 'round',
				objectKind: 'plant',
				width: 30,
				height: 30,
				title: i18next.t('restaurant_designer_section.strings.plant')
			}
		}
		case 'bar': {
			return {
				Component: Bar,
				shape: 'rectangle',
				objectKind: 'bar',
				width: 40,
				height: 40,
				title: i18next.t('restaurant_designer_section.strings.bar')
			}
		}
		case 'exit': {
			return {
				Component: Exit,
				shape: 'rectangle',
				objectKind: 'exit',
				width: 40,
				height: 40,
				title: i18next.t('restaurant_designer_section.strings.exit')
			}
		}
		case 'wc': {
			return {
				Component: Wc,
				shape: 'rectangle',
				objectKind: 'wc',
				width: 40,
				height: 40,
				title: i18next.t('restaurant_designer_section.strings.wc')
			}
		}
		case 'chair': {
			return {
				Component: Chair,
				shape: 'rectangle',
				objectKind: 'chair',
				width: 40,
				height: 40,
				title: i18next.t('restaurant_designer_section.strings.chair')
			}
		}
		case 'barChair': {
			return {
				Component: BarChair,
				shape: 'rectangle',
				objectKind: 'barChair',
				width: 40,
				height: 40,
				title: 'Barhocker' // TODO: add translation
			}
		}
		case 'sofa': {
			return {
				Component: Sofa,
				shape: 'rectangle',
				objectKind: 'sofa',
				width: 140,
				height: 70,
				title: i18next.t('restaurant_designer_section.strings.sofa')
			}
		}
		case 'doorLeft': {
			return {
				Component: DoorLeft,
				shape: 'rectangle',
				objectKind: 'doorLeft',
				width: 35,
				height: 45,
				title: 'LEFT DOOR' // TODO: add translation
			}
		}
		case 'doorRight': {
			return {
				Component: DoorRight,
				shape: 'rectangle',
				objectKind: 'doorRight',
				width: 350,
				height: 45,
				title: 'RIGHT DOOR' // TODO: add translation
			}
		}

		case 'doubleDoors': {
			return {
				Component: DoubleDoors,
				shape: 'rectangle',
				objectKind: 'doubleDoors',
				width: 70,
				height: 45,
				title: 'DOUBLE DOORS' // TODO: add translation
			}
		}
		default: {
			return {
				Component: Round,
				shape: 'round',
				objectKind: 'table',
				width: 60,
				height: 60,
				title: i18next.t('restaurant_designer_section.strings.round')
			}
		}
	}
}

